import { collection, getDocs, db, registerAffiliate, registerCanje as requestCanje, getRedSummary as requestRedSummary, geocode } from "./firestoreApi"

const CATEGORY_LABELS = {
    salud: "Salud", hogar: "Hogar", educacion: "Educación", educación: "Educación",
    comercio: "Comercio", bienestar: "Bienestar", programas: "Programas", otros: "Otros"
}

export const getBeneficios = async () => {
    const snapshot = await getDocs(collection(db, "beneficios"))

    return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        beneficio: doc.data().beneficio || doc.data().txt || "",
        categoria: CATEGORY_LABELS[String(doc.data().categoria || "otros").toLowerCase()] || doc.data().categoria || "Otros"
    }))
}

export const registrarAfiliado = async afiliado => {
    const result = await registerAffiliate(afiliado)
    return result.folio
}

export const getCoordinates = async direccion => {
    if (!direccion) return null

    try {
        return await geocode(direccion)
    } catch (error) {
        return null
    }
}

export const registrarCanje = async ({ aliado, ahorro, registradoPor }) => {
    await requestCanje({ aliadoId: aliado.id, ahorro, registradoPor })
}

export const getRedSummary = async () => {
    return requestRedSummary()
}